export const WORKSPACE_VIEWS = {
    LIST: "LIST",
    TIMELINE: "TIMELINE",
    FLOORPLAN: "FLOORPLAN",
};


// WEBPACK FOOTER //
// ./src/constants/booker.js